import { alpha } from '@mui/material';
import styled from 'styled-components';

export const CalendarStyled = styled.div`
	height: 100%;
	.rbc-calendar {
		font-family: ${props => props.theme.typography.fontFamily};
		background-color: ${props => props.theme.palette.background['paper-elevation-0']};
		border-radius: 5px;
		padding: 0;
		overflow: hidden;
	}

	.rbc-toolbar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 1rem;
	}

	.rbc-toolbar button {
		background-color: ${props => props.theme.palette.background['paper-elevation-0']};
		color: ${props => props.theme.palette.text.primary};
		padding: 7px;
		border-radius: 5px;
		font-weight: 500;
		font-size: 0.8125rem;
		line-height: 1.75;
		cursor: pointer;
		transition: 0.2s all ease;
		font-family: 'Satoshi', 'Helvetica', 'Arial', 'sans-serif';
		:hover {
			background-color: ${p => alpha(p.theme.palette.secondary.main, 0.4)};
		}
	}

	.rbc-toolbar button:focus,
	.rbc-active {
		background-color: ${p => alpha(p.theme.palette.secondary.main, 0.2)} !important;
		color: ${props => props.theme.palette.secondary.main} !important;
		box-shadow: none !important;
	}

	.rbc-toolbar-label {
		font-family: 'HK Grotesk', 'Helvetica', 'Arial', 'sans-serif';
		font-size: ${({ theme }) => theme.typography.h4.fontSize || '1.5rem'};
	}

	.rbc-month-view {
		border: none;
	}

	.rbc-month-row {
		border-bottom: none;
	}

	.rbc-header {
		padding: 0.5rem;
		text-align: center;
		font-weight: 600;
		border-bottom: 1px solid ${props => props.theme.palette.background['paper-elevation-0']};
		background-color: ${props => props.theme.palette.background['paper-elevation-0']};
	}

	.rbc-off-range-bg {
		background-color: ${p => alpha(p.theme.palette.grey[300], 0.3)} !important;
	}

	.rbc-selected {
		background-color: ${p => alpha(p.theme.palette.info.main, 0.3)} !important;
		color: ${props => props.theme.palette.text.primary} !important;
	}

	.rbc-today {
		background-color: ${p => alpha(p.theme.palette.primary.main, 0.2)} !important;
	}

	.rbc-event {
		background-color: ${props => props.theme.palette.background['paper-elevation-0']};
		border: 1px solid ${props => props.theme.palette.info.main};
		color: ${props => props.theme.palette.info.main};
		padding: 0 6px;
		border-radius: 1rem;
		min-height: fit-content !important;
		margin-top: 3px;
		text-align: center;
		transition:
			background-color 250ms cubic-bezier(0.4, 0, 0.2, 1),
			box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1);
	}

	.rbc-event-label {
		visibility: hidden;
		width: 0px !important;
		height: 0px;
		padding: 0px;
	}

	.rbc-show-more {
		margin-top: 5px;
		font-weight: 500;
		color: ${props => props.theme.palette.text.primary};
		text-decoration: underline;
		cursor: pointer;
		background-color: transparent;
	}
	.rbc-row-segment {
		padding: 0 1rem;
	}
`;
